/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_Frame_TrueInputs */

const en_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`true`)
};

const fr_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vrai`)
};

const de_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAHR`)
};

const it_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERO`)
};

const ru_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`истинный`)
};

const es_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verdadero`)
};

const zh_cn2_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真的`)
};

const ja_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真実`)
};

const hi_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्य`)
};

const pt_pt2_dialogue_list_export_drop_frame_true = /** @type {(inputs: Dialogue_List_Export_Drop_Frame_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verdadeiro`)
};

/**
* | output |
* | --- |
* | "true" |
*
* @param {Dialogue_List_Export_Drop_Frame_TrueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame_true = /** @type {((inputs?: Dialogue_List_Export_Drop_Frame_TrueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_Frame_TrueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "de") return de_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "it") return it_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "ru") return ru_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "es") return es_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "ja") return ja_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "hi") return hi_dialogue_list_export_drop_frame_true(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_drop_frame_true(inputs)
	return en_dialogue_list_export_drop_frame_true(inputs)
});